import { configureStore, createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { api } from '~/api/api'
import { portalApi } from '~/api/portal'
import authReducer, { loggedIn, loggedOut, persistKey } from './authSlice'
import clientReducer, { clientSelected, persistClient } from './clientSlice'

// Persistence as a side effect of the action, not a call every caller has to remember:
// somewhere that forgot it would log the operator out on the next refresh.
const persistence = createListenerMiddleware()
persistence.startListening({
  matcher: isAnyOf(loggedIn, loggedOut),
  effect: (action) => persistKey(loggedIn.match(action) ? action.payload : null),
})
persistence.startListening({
  actionCreator: clientSelected,
  effect: (action) => persistClient(action.payload),
})

export function createStore() {
  const store = configureStore({
    reducer: {
      auth: authReducer,
      client: clientReducer,
      [api.reducerPath]: api.reducer,
      // The client dashboard's own API (BIBLE §19.5).
      [portalApi.reducerPath]: portalApi.reducer,
    },
    middleware: (getDefault) =>
      getDefault()
        .prepend(persistence.middleware)
        .concat(api.middleware, portalApi.middleware),
  })
  // Refetch when the tab comes back — the engine has been running the whole time.
  setupListeners(store.dispatch)
  return store
}

export const store = createStore()

export type AppStore = ReturnType<typeof createStore>
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
